export default "__VITE_ASSET__dd18dd91__"